export enum ReportFlowStep {
  Distress = 'distress',
  Symptoms = 'symptoms',
  Summary = 'summary',
  CallbackRequest = 'callbackRequest',
  CallbackReason = 'callbackReason',
  Confirmation = 'confirmation'
}

export interface ReportFormData {
  distressLevel: number;
  reportedSymptoms: ReportedSymptom[];
  callbackRequest?: CallbackRequest;
  [key: string]: string | boolean | number | ReportedSymptom[] | CallbackRequest | undefined;
}

export interface CallbackRequest {
  questionType: 'callbackRequest';
  status: 'answered';
  value?: boolean;
  customMessage?: string;
  additions?: number;
}

export interface CallbackReason {
  id: number;
  text: string;
}

export interface SymptomSection {
  name: string;
  causes: SymptomCause[];
}

export interface SymptomCause {
  id: number;
  name: string;
  is_key: boolean; // should be camelCase in new endpoint
}

export interface ReportedSymptom {
  causeId: number;
  severity: number;
}

export enum Severity {
  Mild = 'mild',
  Moderate = 'moderate',
  Severe = 'severe',
  Worst = 'worst'
}

export enum SeverityLevel {
  Mild = 1,
  Moderate = 2,
  Severe = 3,
  Worst = 4
}

export enum CallbackRequestAnswer {
  Yes = 'yes',
  No = 'no'
}
